import { Size, t } from '@bms2/shared';
import { DatePicker } from '../../components/controls';
import { ModalField } from '../../components/modals/ModalShell';

/**
 * 🔒 The write-off's own day, the further field the Write Off window carries beside its reason (decision 8860).
 * It opens on today in the viewer's zone, which the page hands it, and the entry is dated the day it holds.
 * It stands in its own file because it draws a field and no window: the window is the shared reason window's.
 */
export function WriteOffDateField({ value, onChange }: { value: string; onChange: (next: string) => void }) {
  return (
    <ModalField label={t('invoice.writeOff.date')} required>
      <DatePicker size={Size.Small} label={t('invoice.writeOff.date')} labelHidden value={value} onChange={onChange} mode="date" name="writeOffDate" />
    </ModalField>
  );
}
